import React from 'react'
import FundBasicsItem from '../Shared/FundBasicsItem.jsx'
import { formatDateStandard } from '../../../../global/formatters/string-formatter.js'

const rmCIV = ['EGAXCEMT']
const rmBIV = ['EGAXCEMT', 'BAREVA', 'BARECO', 'BAUSEI', 'BAINEI', 'BAREIT']
const rmBIT = ['BAINEI', 'BAUSEI']

function OverviewIndexAtAGlance({ indexAtaGlance }) {
  let BIVshow,
    CIVshow,
    BITshow = true
  if (rmBIV.includes(indexAtaGlance.blIndxTicket)) {
    BIVshow = false
  }
  if (rmCIV.includes(indexAtaGlance.blIndxTicket)) {
    CIVshow = false
  }
  if (rmBIT.includes(indexAtaGlance.blIndxTicket)) {
    BITshow = false
  }
  return (
    <React.Fragment>
      <h3 className="u-marginBottom3gu">Index At-a-Glance</h3>
      <div className="Grid-striper Reverse-striper u-marginHoriz2gu">
        <div className="Grid Grid--alignBottom Grid--withGutter js-fund-basic-category u-paddingHoriz1gu u-paddingTop3gu">
          <div
            className={`u-flexAlignSelfStart u-size3of12 u-sm-paddingBottom2gu u-sm-sizeFull`}
          >
            <h4 className="u-sm-inlineBlock">Index Basics</h4>{' '}
            <span className="u-textColorLight u-textSecondary">
              as of {formatDateStandard(indexAtaGlance.asOfDate)}
            </span>
          </div>
          <div className="Grid u-size9of12 u-sm-sizeFull">
            {BITshow && (
              <FundBasicsItem
                label="Bloomberg Index Ticker"
                fundValue={indexAtaGlance.blIndxTicket}
              />
            )}
            {BIVshow && (
              <FundBasicsItem
                label="Base Index Value"
                fundValue={indexAtaGlance.baseIndVal}
              />
            )}
            {CIVshow && (
              <FundBasicsItem
                label="Current Index Value"
                fundValue={indexAtaGlance.curIndVal}
              />
            )}
            <FundBasicsItem
              label="Inception Date"
              fundValue={formatDateStandard(indexAtaGlance.inceptionDate)}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default OverviewIndexAtAGlance
